$(document).ready(function() {

    // MENU

    $(document).on('click', '.js-menu-toggle', function(e) {
        e.preventDefault();
        $(this).toggleClass('c-header__hamburger--active');
        $('.js-menu').toggleClass('c-header__main-menu-container--active');

        if ($(this).hasClass('c-header__hamburger--active')) {
            $('body').addClass('u-no-scroll');
        } else {
            $('body').removeClass('u-no-scroll');
        }
    });

    // SUBNAV

    $('.js-subnav-1').appendTo('.js-main-menu > li:nth-child(1)');
    $('.js-subnav-2').appendTo('.js-main-menu > li:nth-child(2)');

    $('.js-main-menu > li').each(function(){
        if($(this).find('.js-subnav').length == 1) {
            $(this).addClass('has-sub');
            $('<a href="#" class="c-header__main-menu-toggle-sub js-toggle-sub"></a>').appendTo($(this));
        }
    });

    $(document).on('click', '.js-toggle-sub', function(e) {
        var subnavEl = $(this).prev('.js-subnav');
        $(this).toggleClass('c-header__main-menu-toggle-sub--active');
        subnavEl.toggleClass('c-header__subnav--active');
    });

    // LANGUAGE MENU

    $(window).click(function() {
        $('.js-language-menu').removeClass('c-header__language-container--active');
    });

    $(document).on('click', '.js-language-menu', function(e) {
        e.stopPropagation();
        $(this).toggleClass('c-header__language-container--active');
    });

    $('.js-projects-carousel-slick').slick({
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        adaptiveHeight: true,
        swipe: true,
        autoplay: true,
        autoplaySpeed: 8000
    });

    // WHAT WE DO LINKS

    $(document).on('click', '.js-link', function (){
        window.location.href = $(this).data('url');
    });

    // BACK LINK

    $(document).on('click', '.js-go-back', function (e){
        e.preventDefault();
        history.back();
    });

    // PRODUCTS

    $(document).on('click', '.js-product-link', function (e){
        e.preventDefault();
        $(this).next('.js-product-detail').addClass('c-products__detail--visible');
        $('body').addClass('u-no-scroll');
    });

    $(document).on('click', '.js-product-detail-close', function (e){
        e.preventDefault();
        $('.js-product-detail').removeClass('c-products__detail--visible');
        $('body').removeClass('u-no-scroll');
    });

    $(document).on('click', '.js-product-detail-link', function (e){
        e.preventDefault();
        $('.js-product-detail').removeClass('c-products__detail--visible');
        $('body').removeClass('u-no-scroll');
        $('html, body').animate({
            scrollTop: $(".c-contact-form").offset().top
        }, 500);
    });

    $(document).keyup(function(e) {
        if (e.key === "Escape") { // escape key maps to keycode `27`
            $('.js-product-detail').removeClass('c-products__detail--visible');
            $('body').removeClass('u-no-scroll');
        }
    });

    // LOCATIONS

    $(document).on('click', '.js-locations-toggle', function (e){
        e.preventDefault();
        $('.js-locations-toggle').removeClass('c-locations__item-toggle--active');
        $('.js-locations-toggle-target').removeClass('c-locations__info-container--active');
        $(this).addClass('c-locations__item-toggle--active');
        $(this).siblings('.js-locations-toggle-target').addClass('c-locations__info-container--active');
    });
});
